import { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import styles from './index.module.scss';
import moment from 'moment';
import { ReviewerInfo, ReviewMediaRendered } from './Common';
import { IS_MOBILE } from 'src/utils/checkClientDeviceType';

const CustomerReviewReply = ({ review, handleProductReviewModalOpen }) => {
  const [showCompleteReviewAndReply, setShowCompleteReviewAndReply] = useState({
    review: false,
    reply: false,
  });
  const { userData } = useSelector((state) => ({
    userData: state.userReducer,
  }));

  return (
    <div className="tw-border-b tw-border-solid tw-border-[#E2E2E2] last:tw-border-none last:tw-border-transparent">
      <div className={styles.customerReviewReplyContainer}>
        <div className="flex items-center justify-between">
          <ReviewerInfo review={review} />
          {userData?.isLogin &&
          review.phone === userData?.data?.phone &&
          !review.status ? (
            <>
              <img
                src="/assets/images/clock-timer.svg"
                className="pointer"
                data-tip
                data-for="review-under-process"
              />
              <ReactTooltip
                id="review-under-process"
                place="bottom"
                effect="solid"
                multiline={true}
                padding="8px"
              >
                <p className="mv0 fw5 f12px">Review under process</p>
              </ReactTooltip>
            </>
          ) : null}
        </div>
        {!!review?.store_item_review_media?.length && (
          <div className="tw-mt-[12px] tw-flex tw-gap-[16px]">
            {review?.store_item_review_media?.map((media, index) => (
              <ReviewMediaRendered
                media={media}
                size={IS_MOBILE ? 84 : 88}
                key={index}
                onClick={() => handleProductReviewModalOpen(index)}
              />
            ))}
          </div>
        )}
        <div className="pt12px">
          <span className="mv0  tw-text-[14px]/[18px] tw-font-normal tw-text-[#111C36]">
            {showCompleteReviewAndReply.review
              ? review?.review
              : review?.review?.substr(0, 219)}
          </span>
          {(review?.review).length > 219 ? (
            <span
              className={styles.readMore}
              onClick={() =>
                setShowCompleteReviewAndReply((prevState) => ({
                  ...prevState,
                  review: !showCompleteReviewAndReply.review,
                }))
              }
            >
              ... Read {showCompleteReviewAndReply.review ? 'Less' : 'More'}
            </span>
          ) : (
            ''
          )}
        </div>
        {review?.reply ? (
          <div className={styles.replyContainer}>
            <p className="mv0 !tw-text-[12px]/[18px] !tw-font-medium !tw-text-[#818181]">
              Seller's reply | {moment(review?.reply_date).format('DD MMMM YYYY')}
            </p>
            <span className="mv0 !tw-mt-[4px] !tw-text-[14px]/[18px] !tw-font-normal !tw-text-[#111C36]">
              {showCompleteReviewAndReply.reply
                ? review?.reply
                : review?.reply?.substr(0, 219)}
            </span>
            {(review?.reply).length > 219 ? (
              <span
                className="c28292C f14px fw5 pointer"
                onClick={() =>
                  setShowCompleteReviewAndReply((prevState) => ({
                    ...prevState,
                    reply: !showCompleteReviewAndReply.reply,
                  }))
                }
              >
                ... Read {showCompleteReviewAndReply.review ? 'Less' : 'More'}
              </span>
            ) : (
              ''
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CustomerReviewReply;
